import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeliveryConstants } from '../../app-core/constants/common-constants';
import { CommonService } from '../../app-core/services/common.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
	deliveryConstants: typeof DeliveryConstants = DeliveryConstants;
	src = 'assets/images/arrowxl-logo-white.svg';
	logoLink = 'https://www.arrowxl.co.uk/';
	showWarning = false;
	alert: any;
	errorMessage = '';
	hideAlert = false;

	constructor(private router: Router, private commonService: CommonService) {}

	ngOnInit() {
		const currentDate = new Date();
		const formattedDate = currentDate.toISOString().slice(0, 19);

		this.commonService.getAlert(formattedDate).subscribe({
			next: (res) => {
				this.alert = res.arrowxl_alert_response;
				if (this.alert.endDateTime > formattedDate) {
					this.showWarning = true;
				} else {
					this.showWarning = false;
				}
			},
			error: (err) => {
				this.errorMessage = err;
			},
		});
	}

	onFaq() {
		const url = this.router.serializeUrl(this.router.createUrlTree(['faq']));
		window.open(url, '_blank');
	}

	closeWarning() {
		this.showWarning = false;
	}
}
